export const API_APP_INQUIRY_URL = process.env.REACT_APP_INQUIRY_API_URL;
export const API_APP_URL = process.env.REACT_APP_API_URL;
export const API_CRM_URL = process.env.REACT_APP_CRM_API_URL;
